import ConnectCrm from 'components/widgets/AccountSettings/ConnectCrm';
import { AccountSettingsModule } from 'components/widgets/AccountSettings/layout/AccountSettingsModule';
import { AccountSettingsSection } from 'components/widgets/AccountSettings/layout/AccountSettingsSection';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { FLAGS } from 'utils/featureFlags';

export const Integrations = () => {
  const { isFlagEnabled } = useFeatureFlags();

  if (!isFlagEnabled(FLAGS.INTEGRATIONS)) {
    return null;
  }

  return (
    <AccountSettingsSection title="Integrations">
      <AccountSettingsModule title="CRM">
        <ConnectCrm />
      </AccountSettingsModule>
    </AccountSettingsSection>
  );
};
